var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.text)?[_c('span',{staticClass:"text--disabled"},[_vm._v(" N/A ")])]:[(this.$slots.default)?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.text)+" ")]]],2)}
var staticRenderFns = []

export { render, staticRenderFns }